import {DataTable} from '@cypro/ui/components/ui/data-table'
import {usePrescribedNameContext} from '@/shared/contexts/prescribed-name'
import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {createColumnHelper} from '@tanstack/react-table'
import {getCoreRowModel, useReactTable} from '@tanstack/react-table'
import {useMemo} from 'react'
import type {TradeName} from '@cypro/engine/schema'
import {openTradeNameDrawer} from '@/modules/products/trade-names/components/trade-name-drawer/util'
import {EmptyState} from '@cypro/ui/components/ui/empty-state'
import {ResourceStatus} from '@/shared/components/ui/resource-status'

const columnHelper = createColumnHelper<TradeName>()

export function TradeNamesTab() {
  const {t} = useTranslate('common')
  const {prescribedName} = usePrescribedNameContext()

  const tradeNames = useMemo(() => {
    if (!prescribedName.tradeNames) return []
    return [...prescribedName.tradeNames].filter(Boolean) as TradeName[]
  }, [prescribedName])

  const columns = useMemo(() => {
    return [
      columnHelper.accessor('name', {
        header: t('name'),
      }),
      columnHelper.accessor('status', {
        header: t('status'),
        cell: ({row}) => <ResourceStatus status={row.original.status} />,
      }),
    ]
  }, [t])

  const table = useReactTable({
    data: tradeNames,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <Tabs.Content value="trade-names" spaceY="8" display="flex" flexDirection="column">
      {tradeNames.length > 0 ? (
        <DataTable table={table} onRowClick={tradeName => openTradeNameDrawer(tradeName)} />
      ) : (
        <EmptyState title={t('no_trade_names_yet')} />
      )}
    </Tabs.Content>
  )
}
